export default __webpack_public_path__ + "static/assets/3673311acab7c2a02d4374375934d208.png";